export const clientConfig = {
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyDsASUF5wwwPpilbaWFw1LtUtpMS8k-d0M',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'nimblez.firebaseapp.com',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'nimblez',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:755676489674:web:67ec77cf40fa9d67105133',
  },
  authEmulatorUrl: import.meta.env.DEV ? import.meta.env.VITE_AUTH_EMULATOR_URL || null : null,
  /** `host:port` of the local Firestore emulator; development builds with the auth emulator only. */
  firestoreEmulatorHost: import.meta.env.DEV && import.meta.env.VITE_AUTH_EMULATOR_URL ? import.meta.env.VITE_FIRESTORE_EMULATOR_HOST || null : null,
};
